import {AppDispatch} from "../store";
import {EnumLanguage} from "../../enums/EnumLanguage";
import {toast} from "react-toastify";
import {modulesApi} from "../../api/modulesApi";
import {modulesSlice} from "../reducers/ModulesSlice";
import {ModuleOrderDto} from "../../api/dto/modules/orders.dto";
import {IModule} from "../../models/IModule";

export const getModulesThunk = () => async (dispatch: AppDispatch) => {
    try {
        const {data} = await modulesApi.getModules()
        const result = data.map<IModule>(module => {
            return {
                ...module,
                title: {
                    [EnumLanguage.en]: module.title_en,
                    [EnumLanguage.ru]: module.title_ru,
                    [EnumLanguage.cn]: module.title_cn,

                },
                description: {
                    [EnumLanguage.en]: module.description_en,
                    [EnumLanguage.ru]: module.description_ru,
                    [EnumLanguage.cn]: module.description_cn,
                },
            }
        })


        dispatch(modulesSlice.actions.setModules(result))
        return true
    } catch (error) {
        console.log(error)
        toast.error('Ошибка при загрузке модулей')
        return true
    }


}

export const updateOrdersModulesThunk = (orders: ModuleOrderDto[]) => async (dispatch: AppDispatch) => {
    try {
        await toast.promise(
            modulesApi.updateOrders(orders),
            {
                pending: 'Обновляем порядок',

                success: {
                    render({data}) {

                        return `${data?.data}`
                    }
                },
                error: 'Какая то ошибка 🤯'
            })


    } catch (error) {
        console.log(error)
        toast.error('Ошибка при при обновлении порядка модулей')
    }
}


interface ISendModuleDataThunk  {
    form: any,
    setIsOpenEditModule: (status: boolean) => void,
    isNewModule: boolean,
}
export const sendModuleDataThunk = ({form, setIsOpenEditModule, isNewModule}: ISendModuleDataThunk) => async (dispatch: AppDispatch) => {
    try {
        if (isNewModule) {
            const createdModule = await modulesApi.sendModuleData(form)

            dispatch(modulesSlice.actions.addModule({
                    ...createdModule.data,
                    title: {
                        [EnumLanguage.ru]: createdModule.data.title_ru,
                        [EnumLanguage.en]: createdModule.data.title_en,
                        [EnumLanguage.cn]: createdModule.data.title_cn,
                    },
                    description: {
                        [EnumLanguage.ru]: createdModule.data.description_ru,
                        [EnumLanguage.en]: createdModule.data.description_en,
                        [EnumLanguage.cn]: createdModule.data.description_cn,
                    }
                }
            ))
        }



        if (!isNewModule) {
            const updatedModule = await modulesApi.sendModuleData(form)
            dispatch(modulesSlice.actions.updateModule({
                    ...updatedModule.data,
                    title: {
                        [EnumLanguage.ru]: updatedModule.data.title_ru,
                        [EnumLanguage.en]: updatedModule.data.title_en,
                        [EnumLanguage.cn]: updatedModule.data.title_cn,
                    },
                    description: {
                        [EnumLanguage.ru]: updatedModule.data.description_ru,
                        [EnumLanguage.en]: updatedModule.data.description_en,
                        [EnumLanguage.cn]: updatedModule.data.description_cn,
                    }
                }
            ))
        }


        toast.success(isNewModule ? 'Модуль успешно создан' : 'Модуль обнволен')
        setIsOpenEditModule(false)
    } catch (error) {

        console.log(123)
        // @ts-ignore
        toast.warning(error.response.data.message)


        console.log(error)
    }



}

export const deleteModuleThunk = (id: number) => async (dispatch: AppDispatch) => {
    try {
        await modulesApi.deleteModule(id)
        dispatch(modulesSlice.actions.deleteModule(id))
        toast.success('Модуль удален')

    } catch (error) {
        console.log(error)
        toast.error('Ошибка при удалении модуля')
    }
}